import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { generatedV2 } from "@generated";
import mutableCopy from "./mutableCopy";
import ResourcePlans from "./ResourcePlans/ResourcePlans";
import PlanningDetails from "./PlanningDetails/PlanningDetails";

function ResourcePlanningMspa({ project_id }) {
  //States
  const [scenarios, setScenarios] = useState([]);
  const [phases, setPhases] = useState([]);
  const [lobs, setLobs] = useState([]);
  const [resources, setResources] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [getResourcePlans] =
    generatedV2.endpoints.v2ListResourcePlans.useLazyQuery();
  const [getServiceCategories] =
    generatedV2.endpoints.v2ListServiceCategorysForAccount.useLazyQuery();
  const [getProject] = generatedV2.endpoints.v2GetProjectById.useLazyQuery();

  useEffect(() => {
    //Get resource-plans
    getResourcePlans({ filter: { project: String(project_id) } })
      .unwrap()
      .then((res) => {
        setScenarios(mutableCopy(res.data) || []);
      });

    // Get Service Categories
    getServiceCategories({})
      .unwrap()
      .then((response) => {
        setLobs(mutableCopy(response.data) || []);
      });

    // Get Project Data with phases and project resources included
    getProject({
      id: String(project_id),
      include: [
        "project-phases",
        "project-phases.phase",
        "project-resources",
        "resource-plans",
      ],
    })
      .unwrap()
      .then((response) => {
        const included = mutableCopy(response.included);

        if (included) {
          //Project Phases
          let projectPhases = included.filter(
            (item) => item.type === "project-phases"
          );
          setPhases(projectPhases);

          //Project Resources
          let projectResources = included.filter(
            (item) => item.type === "project-resources"
          );
          setResources(projectResources);
        }

        setIsLoading(false);
      });
  }, []);

  const routes = (
    <Routes>
      <Route
        index
        element={
          <ResourcePlans
            project_id={project_id}
            scenarios={scenarios}
            setScenarios={(s) => setScenarios(s)}
            isLoading={isLoading}
          />
        }
      />
      <Route
        path=":resource_id"
        element={
          <PlanningDetails
            project_id={project_id}
            scenarios={scenarios}
            setScenarios={(s) => setScenarios(s)}
            isLoading={isLoading}
            phases={phases}
            resources={resources}
            lobs={lobs}
          />
        }
      />
    </Routes>
  );

  return <main>{routes}</main>;
}

export default ResourcePlanningMspa;
